import { useQuery } from '@tanstack/react-query'

import type { GetPatientResponse } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Fetches a single patient by ID, including owner data.
 * Pass `select` to narrow the cached response — e.g. `(r) => r.patient` for callers that only
 * need the patient entity.
 */
export function useGetPatient<T = GetPatientResponse>(
  patientId: string,
  select?: (response: GetPatientResponse) => T
) {
  const api = useOsApi()

  return useQuery({
    queryKey: ['patient', patientId],
    queryFn: async () => {
      const response = await api.get('/patients/:patientId', { params: { patientId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    select,
  })
}
